<section class="content-header">
  <h1 class="result-list-title" *ngIf="license != null && isAdmin">
    {{ license.nom }}
  </h1>

  <div class="btn-group" *ngIf="!isAdmin">

    <div *ngIf="(licenseList$ | async)?.length == 1">
      <h1 style="margin: 0; font-size: 24px; font-family: 'Source Sans Pro', Sans-Serif;">{{ license.nom }}</h1>
    </div>

    <div *ngIf="(licenseList$ | async)?.length > 1">
      <button type="button" class="btn btn-default btn-lg dropdown-toggle" data-toggle="dropdown" *ngIf="license != null"> {{ license.nom }} <span class="caret"></span></button>
      <button type="button" class="btn btn-default btn-lg dropdown-toggle" data-toggle="dropdown" *ngIf="license == null"><span i18n="@@allLicenses">All licenses</span> <span class="caret"></span></button>
      <ul class="dropdown-menu" style="cursor: pointer;">
        <li><a (click)="switchLicense(null)" i18n="@@allLicenses">All licenses</a></li>
        <li *ngFor="let currentLicense of licenseList$ | async">
          <a (click)="switchLicense(currentLicense)">{{ currentLicense.nom }}</a>
        </li>
      </ul>
    </div>

    <div *ngIf="(licenseList$ | async)?.length == 0">
      <h1 style="margin: 0; font-size: 24px; font-family: 'Source Sans Pro', Sans-Serif;" i18n="@@noLicense">No license</h1>
    </div>

  </div>

  <ol class="breadcrumb">
    <li><a><em class="fa fa-signal"></em> CAPA</a></li>
    <li i18n="@@results">Results</li>
    <li *ngIf="license != null">{{ license.nom }}</li>
  </ol>
</section>
<section class="content">
  <div class="row">
    <div class="col-sm-12">
      <div class="box box-capa">
        <div class="box-header">
          <h2 class="box-title" i18n="@@search">Search</h2>
          <div class="box-tools pull-right">
            <button class="btn btn-secondary" (click)="ResetSearch(); Request();"><span i18n="@@reset">Reset</span><span class="fa fa-undo" style="margin-left: 5px"></span></button>
          </div>
        </div>
        <div class="box-body">
          <div class="row">
            <div class="col-sm-4">
              <div class="input-group" *ngIf="activeSearchTab === 'keyword'">
                <div class="input-group-btn">
                  <button type="button" class="btn btn-capa dropdown-toggle" data-toggle="dropdown" aria-expanded="false">
                    <span *ngIf="activeSearchTab === 'keyword'" i18n="@@keyword">Keyword</span>
                    <span *ngIf="activeSearchTab !== 'keyword'" i18n="@@date">Date</span>
                    <span class="fa fa-caret-down" style="margin-left: 5px"></span>
                  </button>
                  <ul class="dropdown-menu">
                    <li (click)="switchTab()">
                      <a>
                        <span *ngIf="inactiveSearchTab === 'keyword'" i18n="@@keyword">Keyword</span>
                        <span *ngIf="inactiveSearchTab !== 'keyword'" i18n="@@date">Date</span>
                      </a>
                    </li>
                  </ul>
                </div>
                <input type="text" class="form-control" [(ngModel)]="searchKeyword" (keyup.enter)="searchMode = 'keyword'; Request()" i18n-placeholder placeholder="Subject, device, group, protector code" />
                <div class="input-group-btn">
                  <button type="button" class="btn btn-capa" (click)="searchMode = 'keyword'; Request();" i18n="@@search">Search</button>
                </div>
              </div>
              <div class="input-group" *ngIf="activeSearchTab === 'date'">
                <div class="input-group-btn">
                  <button type="button" class="btn btn-capa dropdown-toggle" data-toggle="dropdown" aria-expanded="false">
                    <span *ngIf="activeSearchTab === 'keyword'" i18n="@@keyword">Keyword</span>
                    <span *ngIf="activeSearchTab !== 'keyword'" i18n="@@date">Date</span>
                    <span class="fa fa-caret-down" style="margin-left: 5px"></span>
                  </button>
                  <ul class="dropdown-menu">
                    <li (click)="switchTab()">
                      <a>
                        <span *ngIf="inactiveSearchTab === 'keyword'" i18n="@@keyword">Keyword</span>
                        <span *ngIf="inactiveSearchTab !== 'keyword'" i18n="@@date">Date</span>
                      </a>
                    </li>
                  </ul>
                </div>
                <input class="form-control"
                       i18n-placeholder
                       placeholder="Click to select a date range"
                       [(ngModel)]="selectedMoment"
                       [owlDateTimeTrigger]="dt10"
                       [owlDateTime]="dt10"
                       [selectMode]="'range'"
                       (keyup.enter)="searchMode = 'date'; Request()">
                <owl-date-time #dt10 [pickerType]="'calendar'"></owl-date-time>
                <div class="input-group-btn">
                  <button type="button" class="btn btn-secondary"><span class="fa fa-calendar" [owlDateTimeTrigger]="dt10"></span></button>
                  <button type="button" class="btn btn-capa" (click)="searchMode = 'date'; Request()" i18n="@@search">Search</button>
                </div>
              </div>
            </div>
            <div class="col-sm-8 col-xs-10">
              <h4 i18n="@@sortBy" style="display: inline-block">Sort by…</h4>
              <ul class="SortEvaluation" style="display: inline-block; padding-inline-start: 0px">
                <li>
                  <input type="radio" name="optionsRadios" id="optionsRadios3" [checked]="orderBy === 'sujet'" (click)="orderBy = 'sujet'; Request()" />
                  <label class="label-sort" i18n="@@subject" for="optionsRadios3">Subject</label>
                </li>
                <li>
                  <input type="radio" name="optionsRadios" id="optionsRadios2" [checked]="orderBy === 'base'" (click)="orderBy = 'base'; Request()" />
                  <label class="label-sort" i18n="@@base" for="optionsRadios2">Device</label>
                </li>
                <li>
                  <input type="radio" name="optionsRadios" id="optionsRadios1" [checked]="orderBy === 'license'" (click)="orderBy = 'license'; Request()" />
                  <label class="label-sort" i18n="@@install" for="optionsRadios1">License</label>
                </li>
                <li>
                  <input type="radio" name="optionsRadios" id="optionsRadios4" [checked]="orderBy === 'protecteur'" (click)="orderBy = 'protecteur'; Request()" />
                  <label class="label-sort" i18n="@@protection" for="optionsRadios4">Protector</label>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-sm-12">
      <div class="box box-capa">
        <div class="box-header">
          <h2 class="box-title" i18n="@@results">
            Results
          </h2>
        </div>
        <div class="box-body box-result-body">
          <div *ngIf="Evaluations.length < 1">
            <h4 style="text-align: center" i18n="noResult">No result…</h4>
          </div>

          <div class="container-fluid" *ngFor="let evaluation of Evaluations">

<!----------------------- MOBILE LAYOUT --------------------------->
            <div class="mobile-layout">
                  <div class="row">
                    <a [routerLink]="['/capa/result/view/', evaluation.IDEvaluation]" style="cursor: pointer; color: inherit" target="_blank">
                      <strong class="pull-left" style="font-size: 1.3em;">{{ evaluation.Nom }} {{ evaluation.Prenom }}</strong>
                    </a>

                    <a class="pull-right btn btn-link" [style.opacity]="evaluation.Conforme_G && evaluation.Conforme_D ? '100%' : '0%'" (click)="GetCertification(evaluation)" style="padding: unset"><span class="fa fa-print fa-2x" style="color: black"></span></a>

                    <img *ngIf="evaluation.Conforme_D === true" src="assets/images/CAPA_CONTROL_APPROVED_32.png" alt="" class="pull-right">
                    <img *ngIf="evaluation.Conforme_D === false" src="assets/images/CAPA_CONTROL_REJECTED_32.png" alt="" class="pull-right">

                    <img *ngIf="evaluation.Conforme_G === true" src="assets/images/CAPA_CONTROL_APPROVED_32.png" alt="" class="pull-right">
                    <img *ngIf="evaluation.Conforme_G === false" src="assets/images/CAPA_CONTROL_REJECTED_32.png" alt="" class="pull-right">
                  </div>
              <a [routerLink]="['/capa/result/view/', evaluation.IDEvaluation]" style="cursor: pointer; color: inherit" target="_blank">
                  <div class="row">
                    <p class="pull-left" style="margin-bottom: 0">{{ evaluation.PICB_D }}</p>
                  </div>
                  <div class="row">
                    <p class="pull-left" style="margin-bottom: 0"><span *ngIf="(licenseList$ | async)?.length > 1">{{ evaluation.NomLicense }} - </span>{{ evaluation.NomBase }}</p>
                  </div>
                  <div class="row">
                    <p class="pull-left" *ngIf="evaluation.TypeTest === 1"><span i18n="@@expressTestOf">Express test of </span>{{ evaluation.DateDebut | date: 'dd/MM/yyyy' }} <span i18n="@@at"> at </span> {{ evaluation.HeureDebut }}</p>
                    <p class="pull-left" *ngIf="evaluation.TypeTest === 2"><span i18n="@@classicTestOf">Classic test of </span> {{ evaluation.DateDebut | date: 'dd/MM/yyyy' }} <span i18n="@@at"> at </span> {{ evaluation.HeureDebut }}</p>
                    <p class="pull-left" *ngIf="evaluation.TypeTest === 3"><span i18n="@@flashTestOf">Flash test of </span> {{ evaluation.DateDebut | date: 'dd/MM/yyyy' }} <span i18n="@@at"> at </span> {{ evaluation.HeureDebut }}</p>
                    <p class="pull-left" *ngIf="evaluation.TypeTest === 4"><span i18n="@@normalTestOf">Normal test of </span> {{ evaluation.DateDebut | date: 'dd/MM/yyyy' }} <span i18n="@@at"> at </span> {{ evaluation.HeureDebut }}</p>
                    <p class="pull-left" *ngIf="evaluation.TypeTest === 5"><span i18n="@@sevenFrequenciesTestOf">7 frequency test of </span> {{ evaluation.DateDebut | date: 'dd/MM/yyyy' }} <span i18n="@@at"> at </span> {{ evaluation.HeureDebut }}</p>
                    <p class="pull-left" *ngIf="evaluation.TypeTest === 6"><span i18n="@@fitcheckTestOf">Fitcheck test of </span> {{ evaluation.DateDebut | date: 'dd/MM/yyyy' }} <span i18n="@@at"> at </span> {{ evaluation.HeureDebut }}</p>
                  </div>
              </a>
            </div>
<!------------------------- END MOBILE LAYOUT ------------------------------->

<!-------------------------- DESKTOP LAYOUT --------------------------------->
            <div class="row desktop-layout result-container">
              <a [routerLink]="['/capa/result/view/', evaluation.IDEvaluation]" style="cursor: pointer; color: inherit" target="_blank">
                <img style="margin: 0.2% 2% 0 2%" src="assets/images/TestSmall.png" class="pull-left" alt="">
                <div class="col-md-2" style="padding-top: 5px">
                  <div class="row">
                    <strong class="pull-left" style="font-size: 1.05em; cursor: pointer">{{ evaluation.Nom }} {{ evaluation.Prenom }}</strong>
                  </div>
                  <div class="row">
                    <p class="pull-left" *ngIf="evaluation.TypeTest === 1"><span i18n="@@expressTestOf">Express test of </span> {{ evaluation.DateDebut | date: 'dd/MM/yyyy' }} <span i18n="@@at"> at </span> {{ evaluation.HeureDebut }}</p>
                    <p class="pull-left" *ngIf="evaluation.TypeTest === 2"><span i18n="@@classicTestOf">Classic test of </span> {{ evaluation.DateDebut | date: 'dd/MM/yyyy' }}  <span i18n="@@at"> at </span>  {{ evaluation.HeureDebut }}</p>
                    <p class="pull-left" *ngIf="evaluation.TypeTest === 3"><span i18n="@@flashTestOf">Flash test of </span> {{ evaluation.DateDebut | date: 'dd/MM/yyyy' }}  <span i18n="@@at"> at </span>  {{ evaluation.HeureDebut }}</p>
                    <p class="pull-left" *ngIf="evaluation.TypeTest === 4"><span i18n="@@normalTestOf">Normal test of </span> {{ evaluation.DateDebut | date: 'dd/MM/yyyy' }}  <span i18n="@@at"> at </span>  {{ evaluation.HeureDebut }}</p>
                    <p class="pull-left" *ngIf="evaluation.TypeTest === 5"><span i18n="@@sevenFrequenciesTestOf">7 frequency test of </span> {{ evaluation.DateDebut | date: 'dd/MM/yyyy' }}  <span i18n="@@at"> at </span>  {{ evaluation.HeureDebut }}</p>
                    <p class="pull-left" *ngIf="evaluation.TypeTest === 6"><span i18n="@@fitcheckTestOf">Fitcheck test of </span> {{ evaluation.DateDebut | date: 'dd/MM/yyyy' }}  <span i18n="@@at"> at </span>  {{ evaluation.HeureDebut }}</p>
                  </div>
                </div>
                <div class="col-md-offset-1 col-md-2">
                  <p style="margin-top: 7%">{{ evaluation.NomBase }}</p>
                </div>
                <div class=" col-md-2">
                  <p style="margin-top: 7%" *ngIf="(licenseList$ | async)?.length > 1">{{ evaluation.NomLicense }}</p>
                </div>
              </a>
              <div class="col-md-4">
                <a class="btn btn-link" [style.opacity]="evaluation.Conforme_G && evaluation.Conforme_D ? '100' : '0'" (click)="GetCertification(evaluation)" style="float: right;"><span class="fa fa-print fa-2x" i18n-title title="Print your certificate" style="color: black; margin-top: 5px"></span></a>
                <img *ngIf="evaluation.Conforme_D === true" src="assets/images/CAPA_CONTROL_APPROVED_48.png" alt="" class="pull-right">
                <img *ngIf="evaluation.Conforme_D === false" src="assets/images/CAPA_CONTROL_REJECTED_48.png" alt="" class="pull-right">

                <img *ngIf="evaluation.Conforme_G === true" src="assets/images/CAPA_CONTROL_APPROVED_48.png" alt="" class="pull-right">
                <img *ngIf="evaluation.Conforme_G === false" src="assets/images/CAPA_CONTROL_REJECTED_48.png" alt="" class="pull-right">
                <p class="pull-right" style="margin: 3% 2% 0 0; font-size: medium; font-weight: bold">{{ evaluation.PICB_D }}</p>
              </div>
            </div>
<!------------------------- END DESKTOP LAYOUT ---------------------------------->

          </div>
          <ngb-pagination
                  (pageChange)="Request($event)"
                  [maxSize]="5"
                  [rotate]="true"
                  [collectionSize]="nbTotalElements"
                  [pageSize]="nbElementsPerPage"
                  [(page)]="page">
          </ngb-pagination>
        </div>
      </div>
    </div>
  </div>
</section>
<app-account-management-sidebar *ngIf="account != null && !isAdmin" [Account]="account" [licenseList$]="licenseList$" (pushLicenseEvent)="onLicensePush($event)"></app-account-management-sidebar>
